import { render, staticRenderFns } from "./notice-send.vue?vue&type=template&id=56d192c7&scoped=true&"
import script from "./notice-send.vue?vue&type=script&lang=js&"
export * from "./notice-send.vue?vue&type=script&lang=js&"
import style0 from "./notice-send.vue?vue&type=style&index=0&id=56d192c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d192c7",
  null
  
)

export default component.exports